import { render } from "./adminmain.vue?vue&type=template&id=afdd5042&scoped=true&lang=html"
import script from "./adminmain.vue?vue&type=script&lang=js"
export * from "./adminmain.vue?vue&type=script&lang=js"

import "./adminmain.vue?vue&type=style&index=0&id=afdd5042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdd5042"]])

export default __exports__